module.exports = __webpack_public_path__ + "img/mobileselect.04d8649a.jpg";